import React from 'react';

const Word = ({ title, text, truncateValue }) => (
  <div className='detail-field'>
    <label className='detail-field__label'>
      {title}
    </label>

    <span
      className='detail-field__value'
      title={truncateValue ? text : null}
    >
      {text}
    </span>
  </div>
)

export default Word;
